<template>
  <BaseBanner
    v-if="updateAvailable"
    level="info"
    class="txt-center"
  >
    {{ translate('pb2.mainView.updateAvailableBannerMessage') }}
    <BaseButton @click="applyUpdate">
      {{ translate('pb2.mainView.updateAvailableBannerAction') }}
    </BaseButton>
  </BaseBanner>
</template>

<script setup lang="ts">
import BaseBanner from '@nicolaudie-group/ng-ui-kit/components/BaseBanner/BaseBanner.vue'
import BaseButton from '@nicolaudie-group/ng-ui-kit/components/BaseButton/BaseButton.vue'

import useTranslate from '@/composables/useTranslate'
import useServiceWorker from '@/composables/useServiceWorker'

const { translate } = useTranslate()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { updateAvailable, applyUpdate, activated: _activated, offlineReady: _offlineReady } = useServiceWorker()
</script>
